import React from "react";
import logo from '../../img/logo.svg'
import s from './MainHeader.module.css'
import {Box, Typography} from "@mui/material";

export const MainHeader = () => {
    return(
        <div className={s.mainHeader}>
            <Box>
                <Typography fontWeight={`bold`} fontSize={`25px`} color={`#FFC700`}>
                    הדפסת שילוט חנויות
                </Typography>
            </Box>
            <div className={s.imgWrapper}>
                <a href="https://www.keshet-teamim.co.il/" target="_blank" rel="noopener noreferrer">
                    <img src={logo} alt=""/>
                </a>
            </div>
        </div>
    )
};